import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { RoomCreate, RoomModel } from 'types/api'

export function useCreateRoom() {
  const toast = useToast()
  const { t } = useTranslation('toast')
  const queryClient = useQueryClient()
  const onError = useOnError()

  async function createRoom(args: RoomCreate) {
    const res = await apiClient.post<RoomModel>(SNA_PREFIX + `rooms/`, args)
    return res.data
  }

  return useMutation({
    mutationFn: createRoom,
    onSuccess: () => {
      toast.success({ message: t('roomCreated') })
      queryClient.invalidateQueries({ queryKey: ['flats'] })
    },
    onError
  })
}
